import { __assign } from "tslib";
import { createShadows } from "./shadows";
import { createDerivedColors, createColorAliases } from "./colors";
import { createFonts } from "./fonts";
import { createRounding, createRoundingAliases } from "./rounding";
import { createSpacing, createSpacingAliases } from "./spacing";
var themeConfigDefaults = {
    capitalizeButtonLabel: true,
    addDrawerDividers: true,
};
export var createTheme = function (_a) {
    var name = _a.name, config = _a.config, extend = _a.extend, customColorAliases = _a.customColorAliases, customDerivedColors = _a.customDerivedColors, customShadows = _a.customShadows, customRoundingGlobals = _a.customRoundingGlobals, customRoundingAliases = _a.customRoundingAliases, customSpacingAliases = _a.customSpacingAliases, customSpacingGlobals = _a.customSpacingGlobals;
    return function (mode, os) {
        var parentTheme = extend ? extend(mode, os) : undefined;
        // colors
        var derivedColors = __assign(__assign({}, createDerivedColors(mode)), (parentTheme ? parentTheme.colors : {}));
        var colorAliases = __assign(__assign({}, createColorAliases(derivedColors, mode)), (parentTheme ? parentTheme.colors : {}));
        if (customDerivedColors) {
            derivedColors = __assign(__assign({}, derivedColors), customDerivedColors(mode));
            colorAliases = __assign(__assign({}, colorAliases), createColorAliases(derivedColors, mode));
        }
        if (customColorAliases) {
            colorAliases = __assign(__assign({}, colorAliases), customColorAliases(derivedColors, mode));
        }
        var colors = __assign(__assign({}, derivedColors), colorAliases);
        // fonts
        var fonts = __assign(__assign({}, createFonts(os)), (parentTheme ? parentTheme.fonts : {}));
        // shadows
        var shadows = __assign(__assign(__assign({}, createShadows(colors, mode)), (parentTheme ? parentTheme.shadows : {})), (customShadows ? customShadows(colors, mode) : undefined));
        // rounding
        var rounding = __assign(__assign({}, createRounding()), (parentTheme ? parentTheme.rounding : {}));
        if (customRoundingGlobals) {
            rounding = __assign(__assign(__assign({}, rounding), customRoundingGlobals()), createRoundingAliases(customRoundingGlobals()));
        }
        if (customRoundingAliases) {
            rounding = __assign(__assign({}, rounding), customRoundingAliases(rounding));
        }
        // spacing
        var spacing = __assign(__assign({}, createSpacing()), (parentTheme ? parentTheme.spacing : {}));
        if (customSpacingGlobals) {
            spacing = __assign(__assign(__assign({}, spacing), customSpacingGlobals()), createSpacingAliases(customSpacingGlobals()));
        }
        if (customSpacingAliases) {
            spacing = __assign(__assign({}, spacing), customSpacingAliases(spacing));
        }
        return {
            name: name,
            colors: colors,
            fonts: fonts,
            shadows: shadows,
            rounding: rounding,
            spacing: spacing,
            config: __assign(__assign({}, themeConfigDefaults), config),
        };
    };
};
//# sourceMappingURL=theme.js.map